const doc = [({"no":({"js":({"components":({"plans":({"table":({"the_plan_was_deleted":" Abonnementstypen ble slettet."})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;